import { Image as AntdImage, type ImageProps as AntdImageProps } from 'antd'

type ImageProps = AntdImageProps

export function Image({ preview = false, ...props }: ImageProps) {
  return <AntdImage preview={preview} {...props} />
}
